import { ActivationProvider } from '@/lib/activation-context'
import { hasSubscriptionAccess } from '@/lib/billing-access'
import { DealPipelineProvider } from '@/lib/deal-pipeline-provider'
import { hasDisclaimerAcceptance } from '@/lib/disclaimer-access'
import { useSession } from '@/lib/session-context'

export function AuthenticatedDataProviders({ children }) {
  const { currentUser } = useSession()
  const shouldHydrate = hasSubscriptionAccess(currentUser) && hasDisclaimerAcceptance(currentUser)

  return (
    <ActivationProvider shouldHydrate={shouldHydrate}>
      <DealPipelineProvider shouldHydrate={shouldHydrate}>
        {children}
      </DealPipelineProvider>
    </ActivationProvider>
  )
}
